export default __webpack_public_path__ + "static/media/SoccerCamp.8db7bbc7.png";